import { render, staticRenderFns } from "./AllSubmissionsManagement.vue?vue&type=template&id=0089af74&scoped=true"
import script from "./AllSubmissionsManagement.vue?vue&type=script&lang=js"
export * from "./AllSubmissionsManagement.vue?vue&type=script&lang=js"
import style0 from "./AllSubmissionsManagement.vue?vue&type=style&index=0&id=0089af74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0089af74",
  null
  
)

export default component.exports